module.exports = __webpack_public_path__ + "media/img/uploads/solutions-thumb-04-2f3c744476e8001878791d07a116101e.jpg";